import { FC } from "react";
import { useTranslation } from "react-i18next";
import { Container } from "./styles";

import emptyAttachmentsImg from "Static/images/empty-attachments.png";

interface IEmptyAttachmentsProps {
  padding?: number;
}

const EmptyAttachments: FC<IEmptyAttachmentsProps> = ({ padding }) => {
  const { t } = useTranslation('activities');
  return (
    <Container $padding={padding}>
      <img
        src={emptyAttachmentsImg}
        alt=""
      />
      <span className="title">{t('empty.noAttachmentsTitle')}</span>
      <span className="description">
        {t('empty.noAttachments')}
      </span>
    </Container>
  )
}

export default EmptyAttachments;
